import { AnimatedLink } from "@/components/common/animated-link"

export const NavItem = ({
  to,
  title,
  titleEnglish,
}: {
  to: string
  title: string
  titleEnglish: string
}) => (
  <li className="transition-all duration-300">
    <AnimatedLink
      to={to}
      className={`
        text-[14px] font-bold
        whitespace-nowrap
      `}
    >
      <span
        className={`
          block
          text-sub01
          text-[12px] font-medium
          m-0 md:mb-1
        `}
      >
        {titleEnglish}
      </span>
      {title}
    </AnimatedLink>
  </li>
)
